import { Component } from '@angular/core';

@Component({
  selector: 'app-fn-request-card-modal',
  templateUrl: './fn-request-card-modal.component.html',
  styleUrls: ['./fn-request-card-modal.component.scss']
})
export class FnRequestCardModalComponent {

}
